import $ from 'jquery';

$(document).ready(function(){
	$('.tabs__nav li ').each(function(){
		let t = $(this).find('a').attr('data-bs-target');
		if (!$(t).children().length){
			$(this).hide();
		}
	})
	
})